import logger from '@libs/log';

declare global {
  interface Window {
    zE: (
      widget: string,
      action: string,
      options: Record<string, { value: string; readOnly: boolean }>
    ) => void;
  }
}

function useZendesk() {
  function openZendesk() {
    if (typeof window !== 'undefined' && typeof window.zE === 'function') {
      window.zE('webWidget', 'show', {});
      window.zE('webWidget', 'open', {});
    } else {
      logger.warn('Zendesk widget is not loaded yet.');
    }
  }

  return { openZendesk };
}

export default useZendesk;
